import StorageHelper from "../helpers/StorageHelper";
import { history } from "./index";

class SessionService {
  constructor() {
    this.storageHelper = new StorageHelper();
  }

  getUsuario() {
    const dadosSession = this.storageHelper.getLocal("dados");
    if (!dadosSession) {
      return null;
    }
    const dados = JSON.parse(dadosSession);
    return dados.usuario;
  }

  getEmpresa() {
    const dadosSession = this.storageHelper.getLocal("dados");
    if (!dadosSession) {
      return null;
    }
    const dados = JSON.parse(dadosSession);
    return dados.empresa;
  }

  getEmpresaRelatorio() {
    const dadosSession = this.storageHelper.getLocal("dados");
    const dados = JSON.parse(dadosSession);
    const empresa = dados.empresa;
    return {
      imagemLogo: empresa.imagemLogo,
      fantasia: empresa.fantasia,
      cnpjCpf: empresa.cnpjCpf,
      enderecoLogradouro: empresa.enderecoLogradouro,
      enderecoLogradouroNumero: empresa.enderecoLogradouroNumero,
      enderecoBairro: empresa.enderecoBairro,
      enderecoCidade: empresa.enderecoCidade,
      enderecoUF: empresa.enderecoUF,
    };
  }

  getDadosOffline() {
    const dadosSession = this.storageHelper.getLocal("dados-offline");
    if (!dadosSession) {
      return null;
    }
    return JSON.parse(dadosSession);
  }

  setNomePdvOffline(nomePdv) {
    const dadosSession = this.storageHelper.getLocal("dados-offline");
    if (dadosSession) {
      const dados = JSON.parse(dadosSession);
      dados.nomePdvOffline = nomePdv;
      this.storageHelper.setLocal("dados-offline", JSON.stringify(dados));
    }
  }

  setSincronizacaoInicial(sincronizacaoInicial) {
    const dadosSession = this.storageHelper.getLocal("dados-offline");
    if (dadosSession) {
      const dados = JSON.parse(dadosSession);
      dados.sincronizacaoInicial = sincronizacaoInicial;
      this.storageHelper.setLocal("dados-offline", JSON.stringify(dados));
    }
  }

  setEmpresa(empresa) {
    const dadosSession = this.storageHelper.getLocal("dados");
    const dados = JSON.parse(dadosSession);
    dados.empresa = empresa;
    this.storageHelper.setLocal("dados", JSON.stringify(dados));
  }

  setConfiguracoesEmpresa(configuracoesData) {
    if (configuracoesData || Object.keys(configuracoesData).length > 0) {
      this.criarConfiguracoesEmpresa(configuracoesData);
    }
  }

  setConfiguracoesEmpresaOnline(configuracoesData) {
    if (configuracoesData || Object.keys(configuracoesData).length > 0) {
      this.criarConfiguracoesEmpresa(configuracoesData);
      const dadosOffline = this.storageHelper.getLocal("dados-offline");
      if (dadosOffline) {
        const dadosOfflineObjeto = JSON.parse(dadosOffline);
        dadosOfflineObjeto.configuracoes = configuracoesData;
        this.storageHelper.setLocal(
          "dados-offline",
          JSON.stringify(dadosOfflineObjeto),
        );
      }
    }
  }

  criarConfiguracoesEmpresa(configuracoesData) {
    const configuracoes = {
      diasVencimentoOrcamento: configuracoesData.diasVencimentoOrcamento,
      limiteCredito: configuracoesData.limiteCredito,
      inadimplencia: configuracoesData.inadimplencia,
      operacaoFiscalPdvPadraoId: configuracoesData.operacaoFiscalPdvPadraoId,
      operacaoFiscalPdvSecundariaId:
        configuracoesData.operacaoFiscalPdvSecundariaId,
      operacaoFiscalVendasPadraoId:
        configuracoesData.operacaoFiscalVendasPadraoId,
      operacaoFiscalMdfePadraoId: configuracoesData.operacaoFiscalMdfePadraoId,
      operacaoFiscalComprasPadraoId:
        configuracoesData.operacaoFiscalComprasPadraoId,
      cfopComprasPadraoId: configuracoesData.cfopComprasPadraoId,
      precificacaoNfEntrada: configuracoesData.precificacaoNfEntrada,
      margemCalculo: configuracoesData.margemCalculo,
      visualizarImpressaoEmissao: configuracoesData.visualizarImpressaoEmissao,
      obrigatoriedadeMeioPagamento:
        configuracoesData.obrigatoriedadeMeioPagamento,
      descontoVendaItem: configuracoesData.descontoVendaItem,
      despesaVendaItem: configuracoesData.despesaVendaItem,
      freteVendaItem: configuracoesData.freteVendaItem,
      zerarSaldoAnteriorCaixa: configuracoesData.zerarSaldoAnteriorCaixa,
      utilizarSuprimentoSangria: configuracoesData.utilizarSuprimentoSangria,
      buscaProdutosCodigoBarras: configuracoesData.buscaProdutosCodigoBarras,
      inicialCodigoBarrasBalanca: configuracoesData.inicialCodigoBarrasBalanca,
      leituraPadraoBalanca: configuracoesData.leituraPadraoBalanca,
      vendaEstoqueNegativo: configuracoesData.vendaEstoqueNegativo,
      impressoraEtiqueta: configuracoesData.impressoraEtiqueta,
      impressoraTermica: configuracoesData.impressoraTermica,
      impressaoDiretaPdv: configuracoesData.impressaoDiretaPdv,
      confirmacaoImpressaoPdv: configuracoesData.confirmacaoImpressaoPdv,
      meioPagamentosPadroesConfiguracoes:
        configuracoesData.meioPagamentosPadroesConfiguracoes.map(
          (meioPagamentoConfiguracao) => {
            return {
              id: meioPagamentoConfiguracao.id,
              config: meioPagamentoConfiguracao.configuracaoId,
              meioPa: meioPagamentoConfiguracao.meioPagamentoId,
              pct_co: meioPagamentoConfiguracao.pct_configuracao_id,
            };
          },
        ),
    };
    const dadosSession = this.storageHelper.getLocal("dados");
    const dados = JSON.parse(dadosSession);
    dados.empresa.configuracoes = configuracoes;
    this.storageHelper.setLocal("dados", JSON.stringify(dados));
  }

  getEmpresaAndUsuario() {
    const dadosSession = this.storageHelper.getLocal("dados");
    return JSON.parse(dadosSession);
  }

  getPermisoes() {
    const dadosSession = this.storageHelper.getLocal("dados");
    if (dadosSession) {
      const dados = JSON.parse(dadosSession);
      if (dados?.usuario && Object.keys(dados.usuario).length > 0) {
        return dados.usuario.perfilUsuario.permisoes;
      }
    }
    return [];
  }

  setToken(token) {
    this.storageHelper.setLocal("token", token);
  }

  setDadosOffline(dados) {
    this.storageHelper.setLocal("dados-offline", JSON.stringify(dados));
  }

  setPdvOnlineStatus(status) {
    const dadosSession = this.storageHelper.getLocal("dados-offline");
    if (dadosSession) {
      const dados = JSON.parse(dadosSession);
      dados.pdvOnLine = status;
      this.storageHelper.setLocal("dados-offline", JSON.stringify(dados));
    }
  }

  setSession(data) {
    this.storageHelper.setLocal("token", data.token);
    this.storageHelper.setLocal("dados", JSON.stringify(data.dados));
    if (data?.dados?.empresa?.modoOfflinePdv) {
      const dadosOfflineGavacao = {
        pdvOnLine: true,
        empresaId: data.dados.empresa.id,
        configuracoes: null,
        sincronizacaoInicial: false,
      };
      const dadosOffline = this.storageHelper.getLocal("dados-offline");
      if (dadosOffline) {
        const dadosOfflineObjeto = JSON.parse(dadosOffline);
        dadosOfflineGavacao.configuracoes = dadosOfflineObjeto.configuracoes;
        dadosOfflineGavacao.pdvOnLine = dadosOfflineObjeto.pdvOnLine;
        dadosOfflineGavacao.nomePdvOffline = dadosOfflineObjeto.nomePdvOffline;
      }
      this.storageHelper.setLocal(
        "dados-offline",
        JSON.stringify(dadosOfflineGavacao),
      );
    }
  }

  setConfiguracoesEmpresaOffline() {
    const dadosOffline = this.storageHelper.getLocal("dados-offline");
    const configuracoes = JSON.parse(dadosOffline).configuracoes;
    if (configuracoes || Object.keys(configuracoes).length > 0) {
      this.criarConfiguracoesEmpresa(configuracoes);
    }
  }

  deslogar() {
    this.storageHelper.removeLocal("token");
    this.storageHelper.removeLocal("rotinas");
    this.storageHelper.removeLocal("theme");
    this.storageHelper.removeLocal("dados");
    this.storageHelper.removeSession("notificacao");
    this.storageHelper.removeLocal("bancoCaixaIdPdv");
    history.push("/login");
  }
}

export default SessionService;
